import { render, staticRenderFns } from "./BadwordsBlacklistPage.vue?vue&type=template&id=240c5047&scoped=true"
import script from "./BadwordsBlacklistPage.vue?vue&type=script&lang=js"
export * from "./BadwordsBlacklistPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c5047",
  null
  
)

export default component.exports